import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Carousel from "react-bootstrap/Carousel";
import highlightedPestList from "../../variables/highlightedPestList";
import "./HomepageCarousel.scss";

const HomepageCarousel = () => {
  const [isPlaying, setIsPlaying] = useState(true);
  const [carouselIndex, setCarouselIndex] = useState(0);
  const pauseRef = useRef(null);
  const navigate = useNavigate();

  const handleSelect = (selectedIndex) => {
    setCarouselIndex(selectedIndex);
  };

  const togglePlay = () => {
    setIsPlaying((value) => !value);
  };

  const slideNames = Array.from(highlightedPestList, (x) => x.commonName);

  // Pause/play button
  useEffect(() => {
    const buttonText = isPlaying ? "Pause" : "Play";
    if (pauseRef.current) {
      pauseRef.current.innerText = buttonText;
    }
  }, [isPlaying]);

  // Initial load
  useEffect(() => {
    const carouselIndicators = document.getElementsByClassName(
      "carousel-indicators"
    )[0];
    const pauseButton = document.createElement("button");
    pauseButton.className = "pause-button";
    pauseButton.innerText = "Pause";
    pauseButton.addEventListener("click", togglePlay);
    pauseRef.current = pauseButton;
    if (carouselIndicators) {
      carouselIndicators.append(pauseRef.current);
    }
  }, []);

  return (
    <Carousel
      className="homepage-carousel"
      activeIndex={carouselIndex}
      pause="hover"
      onSelect={handleSelect}
      data-bs-theme="dark"
      controls={true}
      interval={isPlaying ? 6000 : null}
      indicatorLabels={slideNames}
    >
      {highlightedPestList.map((pest) => {
        return (
          <Carousel.Item key={pest.commonName}>
            <img
              src={pest.pestImageURL}
              alt={pest.commonName}
              className="carousel-highlighted-pest-image"
            />
            <Carousel.Caption>
              <div className="highlighted-pest-common-name">
                {pest.commonName}
              </div>
              <div className="highlighted-pest-scientific-name">
                {pest.scientificName}
              </div>
              <button
                className="usa-button"
                onClick={() => navigate(pest.learnMoreLink)}
              >
                View Info with Map
              </button>
            </Carousel.Caption>
          </Carousel.Item>
        );
      })}
    </Carousel>
  );
};

export default HomepageCarousel;
